import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {UserService} from '../services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {
  loggedIn: boolean;

  constructor(private userService: UserService) {
  }
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.userService.isAdmin();
  }
}
